import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_BOLD = 'bold';

export const DEFAULTS_BOLD: Partial<PlatePluginOptions> = {
  hotkey: 'mod+b',
};
